import type { FeatureCollection } from "geojson";
import MapComponent from "components/Map/Map";
import { MapOutput } from "interfaces/interfaces";
import FullScreenModal from "modules/FullScreenModal/FullScreenModal";
import { ProductMeasurementJob } from "generated/graphql";

interface MapModalProps {
  onOpen?: () => void;
  onClose: () => void;
  open: boolean;
  onSave?: (data: MapOutput) => Promise<boolean | void> | boolean | void;
  onChange?: (data: MapOutput) => void;
  guided: boolean;
  initialArea: FeatureCollection | null;
  initialCenter?: [number, number] | null;
  hideLocation: boolean;
  showTools?: [keyof typeof ProductMeasurementJob];
  measureMode?: boolean;
  closeOnSave?: boolean;
  children?: React.ReactNode;
  onFeatureSelect?: (featureId: string) => void;
  saveLabel?: string;
  highlightedFeatureId?: string | null;
}
const isTouchDevice = (): boolean => {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    // @ts-ignore
    navigator.msMaxTouchPoints > 0
  );
};

const useTouchControls = (): boolean => {
  const isMobile = isTouchDevice();
  return isMobile;
};

const isTouch = useTouchControls();
export default function MapModal({
  onClose,
  onSave,
  guided = false,
  open,
  initialArea,
  initialCenter,
  hideLocation,
  showTools,
  closeOnSave = true,
  children,
  onFeatureSelect,
  saveLabel,
  onChange,
  highlightedFeatureId,
}: Partial<MapModalProps>) {
  const sendSaveOnClose = async (data: MapOutput): Promise<boolean | void> => {
    if (onSave) {
      const success = await onSave(data);
      if (closeOnSave && success !== false) {
        onClose?.();
      }
      return success;
    }
  };
  const createIslandConfirmation = (callback: () => void): boolean => {
    if (confirm("Do you want to create an island?")) {
      callback();
      return true;
    }

    return false;
  };
  return (
    <FullScreenModal onClose={onClose} open={open}>
      <div style={{ position: "relative" }}>
        <MapComponent
          createIslandConfirmation={createIslandConfirmation}
          readonly={false}
          onSave={sendSaveOnClose}
          initialArea={initialArea}
          initialFeatures={null}
          initialCenter={initialCenter}
          guidedControls={guided}
          isTouch={isTouch}
          hideLocation={hideLocation}
          showTools={showTools}
          close={onClose}
          onFeatureSelect={onFeatureSelect}
          saveLabel={saveLabel}
          onChange={onChange}
          highlightedFeatureId={highlightedFeatureId}
        />
        {children}
      </div>
    </FullScreenModal>
  );
}
